import store from "../store/index";

export function toggleSideBar() {
  /**
   * If the screen is a mobile then close the sidebar
   */
  store.dispatch("toggleSideBar", window.innerWidth > 1359);
}
